import { ReactNode, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { showToast } from '@/components/ui/toast';
import { useRoutePermission } from '@/hooks/use-filtered-menu';

interface RoutePermissionGuardProps {
  children: ReactNode;
}

/**
 * Route-level permission guard that redirects users to dashboard
 * if they don't have permission to access the current route
 */
export const RoutePermissionGuard = ({
  children,
}: RoutePermissionGuardProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasRoutePermission = useRoutePermission(location.pathname);

  useEffect(() => {
    if (!hasRoutePermission) {
      // Show toast notification
      showToast(
        "Access denied. You don't have permission to view this page. Contact your administrator.",
        false,
        {
          position: 'top-right',
        }
      );

      // Redirect to dashboard
      navigate('/', { replace: true });
    }
  }, [hasRoutePermission, navigate]);

  // If user doesn't have permission, don't render children
  // The useEffect will handle the redirect
  if (!hasRoutePermission) {
    return null;
  }

  return <>{children}</>;
};
